import {
  ToggleInlineStyle
} from './inline-style'

export class Underline extends ToggleInlineStyle {
  getInlineStyle = () => 'UNDERLINE'

  getButtonText = () => 'U'
}



/** WEBPACK FOOTER **
 ** ./lib/toggle/inline-style/underline.js
 **/